import React from "react";
const Dash: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (props) => (
  <svg
    width="12"
    height="3"
    viewBox="0 0 12 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.1368 0.0159998V2.848H0.96076V0.0159998H11.1368Z"
      fill="#2D224C"
    />
  </svg>
);

export default Dash;
